export { default } from './RetailersList';
